//#region import libraries
import React from 'react';
//custom component
import { Container } from "_atoms";
//css
import 'react-datetime/css/react-datetime.css';
//react-table
import { useTable } from 'react-table';
//#endregion

const AdminTable = ({ columns, data }) => {

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }); // useTable hook

  return (
    <Container>
      <table {...getTableProps()} style={{ width: '100%' }}>

        {/* column headers */}
        <thead style={{ borderStyle: 'solid' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th style={{ borderBottomWidth: '1px', borderBottomColor: '#307FE2', borderBottomStyle: 'solid' }} {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>

        {/* body */}
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr className='clickableRow' {...row.getRowProps()} style={{ borderBottomWidth: '1px', borderBottomColor: '#307FE2', }}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                })}
              </tr>
            );
          })}
        </tbody>

      </table>
    </Container>
  );
}

export default AdminTable;

